var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineRepeatCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.72V9.95a.85.85 0 0 0-.85-.85H7.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.4c1.3 0 2.35 1.06 2.35 2.35v1.77c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66 10.56 6.97 8.87a.754.754 0 0 1 0-1.06l1.69-1.69c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L8.56 8.34 9.72 9.5c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM9.1 16.41c-1.3 0-2.35-1.06-2.35-2.35v-1.77c0-.41.34-.75.75-.75s.75.34.75.75v1.77c0 .47.38.85.85.85h7.4c.41 0 .75.34.75.75s-.34.75-.75.75H9.1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.28 17.87a.754.754 0 0 1 0-1.06l1.16-1.16-1.16-1.16a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.69 1.69c.29.29.29.77 0 1.06l-1.69 1.69c-.14.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 6.07 6.07 1.25 12 1.25S22.75 6.07 22.75 12 17.93 22.75 12 22.75 1.25 17.93 1.25 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75 2.75 6.9 2.75 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRepeatCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-repeat-circle.69a315576667ba9f2d61c7e8dc8ab950.svg";
export { ForwardRef as ReactComponent };